// Draggable-pin map for a private place on /settings/privacy. Reuses
// AdminPlaceMapView with the place form's input names: dragging the pin writes
// place[lat] and place[lng] and fires the form's phx-change. The element is
// only rendered once the place has a pin, from the address search or the
// place being edited. Controls are stripped down to geolocate + zoom.
export const PrivacyPlaceMapHook: {
  el?: HTMLElement
  mounted: () => void
  destroyed: () => void
  unMountComponent?: (() => void) | undefined
  isDestroyed?: boolean
} = {
  mounted() {
    if (!this.el) {
      return
    }

    const rootElement = this.el
    const coordinatesStr = rootElement.dataset.coordinates

    // The circle the place covers; the LiveView pushes update-place-radius
    // when the form's radius changes
    const radiusM = Number(rootElement.dataset.radiusM) || null

    let coordinates = null
    if (coordinatesStr && coordinatesStr !== 'null') {
      try {
        coordinates = JSON.parse(coordinatesStr)
      } catch (e) {
        console.error('Failed to parse coordinates:', e)
      }
    }

    void import('../../react/views/AdminPlaceMapView')
      .then(({ AdminPlaceMapView }) => {
        if (this.isDestroyed) {
          return
        }

        this.unMountComponent = AdminPlaceMapView({
          rootElement,
          liveView: this,
          placeData: { id: '', coordinates },
          inputOptions: {
            latInputName: 'place[lat]',
            lngInputName: 'place[lng]',
            // The form has no JSON coordinates input; the view skips a missing one.
            hiddenInputId: 'private-place-coordinates',
          },
          minimalControls: true,
          radiusM,
        })
      })
      .catch((error) => {
        console.error('[PrivacyPlaceMapHook] Failed to load map view:', error)
      })
  },
  destroyed() {
    this.isDestroyed = true
    this.unMountComponent?.()
  },
}
